'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('../SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavData = (_temp = _class = function (_SvgIcon) {
  _inherits(NavData, _SvgIcon);

  function NavData() {
    _classCallCheck(this, NavData);

    return _possibleConstructorReturn(this, (NavData.__proto__ || Object.getPrototypeOf(NavData)).apply(this, arguments));
  }

  _createClass(NavData, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'defs',
            null,
            _react2['default'].createElement(
              'style',
              null,
              '.cls-4{fill:none;stroke:#2c2f43}.cls-6{stroke-linecap:round;stroke-linejoin:round}.cls-4{stroke-miterlimit:10}.cls-6{stroke:#3f4158;fill:#3f4158}'
            )
          ),
          _react2['default'].createElement('path', {
            d: 'M24.33 35.52l-21.24.15A2.11 2.11 0 0 1 1 33.58L.75 3A2.11 2.11 0 0 1 2.84.87L19.13.75c0 .25 7.11 7.15 7.11 7.15l.18 25.5a2.11 2.11 0 0 1-2.09 2.12z',
            strokeWidth: '1.13',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: '#2c2f43',
            fill: 'none'
          }),
          _react2['default'].createElement('path', {
            d: 'M24.33 35.52l-21.24.15A2.11 2.11 0 0 1 1 33.58L.75 3A2.11 2.11 0 0 1 2.84.87L19.13.75c0 .25 7.11 7.15 7.11 7.15l.18 25.5a2.11 2.11 0 0 1-2.09 2.12z',
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: '#2c2f43',
            fill: 'none'
          }),
          _react2['default'].createElement('path', {
            d: 'M25.9 8.24h-5a2.11 2.11 0 0 1-2.12-2.09v-5.1',
            fill: '#2c2f43',
            strokeWidth: '.94',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: '#2c2f43'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 18.127 11.245)',
            d: 'M13.09 10.45h10.05v1.37H13.09z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 16.72 14.035)',
            d: 'M13.11 13.81h6.53v1.37h-6.53z'
          }),
          _react2['default'].createElement('path', {
            className: 'cls-4',
            transform: 'rotate(-.41 6.942 12.602)',
            d: 'M4.8 10.39h4.66v4.66H4.8z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 15.302 19.62)',
            d: 'M13.15 19.05h5.12v1.37h-5.12z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 18.087 22.424)',
            d: 'M13.18 22.4h8.64v1.37h-8.64z'
          }),
          _react2['default'].createElement('path', {
            className: 'cls-4',
            transform: 'rotate(-.41 6.912 20.987)',
            d: 'M4.86 18.98h4.66v4.66H4.86z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 18.067 28.014)',
            d: 'M13.21 27.06h8.99v1.37h-8.99z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 15.262 30.799)',
            d: 'M13.23 30.43h4.06v1.37h-4.06z'
          }),
          _react2['default'].createElement('path', {
            className: 'cls-4',
            transform: 'rotate(-.41 6.882 29.371)',
            d: 'M4.92 27h4.66v4.66H4.92z'
          }),
          _react2['default'].createElement('path', {
            stroke: '#3f4158',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            fill: 'none',
            d: 'M33.31 12.95l3.76 14.52-3.83.99-3.76-14.52 1.06-3.52 2.77 2.53z'
          }),
          _react2['default'].createElement('path', {
            className: 'cls-6',
            transform: 'rotate(-14.52 35.428 29.043)',
            d: 'M33.46 27.93h3.95v2.23h-3.95z'
          }),
          _react2['default'].createElement('path', { className: 'cls-6', d: 'M33.52 13.75l-3.83 1' })
        );
      }

      return render;
    }()
  }]);

  return NavData;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 38.13 36.42'
}, _temp);
exports['default'] = NavData;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Assignment.js
// module id = 713
// module chunks = 32